import React from 'react'
import Trophy from "../..//assets/images/TodayPrizeScreen/trophy.svg"
import '../../assets/css/style.scss'

export default function Announcement({title}) {
    return (
        <div className='row d-flex justify-content-between align-items-center announcement  mt-2'>
            <div className='ml-2'>
                <img src={Trophy} />
                <span className=' float-right mt-1 announcement-heading1'><span>{title}</span></span>
            </div>
            <div className='float-right mr-2 mb-2 announcement-heading2'><span>View All</span></div>

        </div>
    )
}
